'use client'

import React from 'react'
import { useLenis } from '@/providers/LenisProvider'

interface SmoothScrollLinkProps {
  href: string
  children: React.ReactNode
  className?: string
  duration?: number
  offset?: number
}

export const SmoothScrollLink: React.FC<SmoothScrollLinkProps> = ({
  href,
  children,
  className = '',
  duration = 1.2,
  offset = 0,
}) => {
  const { lenis } = useLenis()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()

    if (lenis && href.startsWith('#')) {
      const targetId = href.substring(1)
      const targetElement = document.getElementById(targetId)

      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - offset

        lenis.scrollTo(offsetPosition, {
          duration,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        })
      }
    }
  }

  return (
    <a href={href} onClick={handleClick} className={className}>
      {children}
    </a>
  )
}
